import { render, staticRenderFns } from "./SaveBuildingSchedulePositions.vue?vue&type=template&id=616f8f98"
import script from "./SaveBuildingSchedulePositions.vue?vue&type=script&lang=js"
export * from "./SaveBuildingSchedulePositions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports